import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const employeeCategoryImporterSelectors = importerSelectors('employeeCategory.importer');

export default employeeCategoryImporterSelectors;
